import {Choice} from 'platform/components';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';

import {useSelectedAuthProfile} from '../hooks/useSelectedAuthProfile';

const WITHOUT_AUTHORIZATION_PROFILE_VALUE = 'withoutAuthorization';
const AUTH_PROFILE_MENU_MAX_HEIGHT_STEPS = 33;

export function UserAvatarAuthProfileChoice() {
  const {
    isLoading,
    isError,
    hasNoProfiles,
    profileOptions,
    selectedAuthProfile,
    setSelectedAuthProfile,
  } = useSelectedAuthProfile();

  const options = [
    ...profileOptions.map((profile) => ({
      label: profile.name,
      value: profile.authorizationProfileId,
    })),
    {
      label: i18n.t('entity.header.labels.withoutAuthorization'),
      value: WITHOUT_AUTHORIZATION_PROFILE_VALUE,
    },
  ];

  const handleProfileChange = (authorizationProfileId: string | null) => {
    if (
      isNil(authorizationProfileId) ||
      authorizationProfileId === WITHOUT_AUTHORIZATION_PROFILE_VALUE
    ) {
      setSelectedAuthProfile(null);
      return;
    }

    const profile = profileOptions.find(
      (profileOption) => profileOption.authorizationProfileId === authorizationProfileId
    );

    if (isNil(profile)) {
      return;
    }

    setSelectedAuthProfile({
      authorizationProfileId: profile.authorizationProfileId,
      authorizationId: profile.authorizationId,
    });
  };

  if (isError) {
    return null;
  }

  return (
    <Choice<string>
      label={i18n.t('page.settings.labels.profile')}
      data-testid="layout-header-authorizationProfile"
      name="authorizationProfile"
      value={selectedAuthProfile?.authorizationProfileId ?? WITHOUT_AUTHORIZATION_PROFILE_VALUE}
      options={options}
      onChange={handleProfileChange}
      closeMenuOnScroll={false}
      isNotClearable
      isLoading={isLoading}
      isDisabled={isLoading || hasNoProfiles}
      maxMenuHeight={AUTH_PROFILE_MENU_MAX_HEIGHT_STEPS}
    />
  );
}
